// src/utils/normalizeMeta.js


export function normalizeMeta(rawMeta, reqParams = {}, itemsLen = 0) {
  const m = rawMeta || {};

  const page = Number(m.page ?? reqParams.page ?? 1);
  const page_size = Number(m.page_size ?? reqParams.page_size ?? reqParams.limit ?? 10);

  // offset
  const skip = Number(m.skip ?? (page - 1) * page_size);
  const limit = Number(m.limit ?? page_size);

  // total
  const total =
    m.total !== undefined
      ? Number(m.total)
      : m.total_pages !== undefined
      ? Number(m.total_pages) * limit
      : undefined;

  let has_next = m.has_next;
  let has_prev = m.has_prev;

  if (total !== undefined) {
    const total_pages = Math.max(1, Math.ceil(total / limit));
    has_prev = has_prev ?? page > 1;
    has_next = has_next ?? page < total_pages;
    return { page, page_size, skip, limit, total, total_pages, has_next, has_prev };
  }

  has_prev = has_prev ?? page > 1;
  has_next = has_next ?? Number(itemsLen ?? 0) === limit;

  return { page, page_size, skip, limit, total: undefined, total_pages: undefined, has_next, has_prev };
}


export function buildListParams({ page, page_size, extra = {} }) {
  return {
    page,
    page_size,
    skip: (page - 1) * page_size,
    limit: page_size,
    ...extra,
  };
}
